<svg
  id="enitZalIYVj1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <defs>
    <linearGradient
      id="enitZalIYVj76-fill"
      x1="139.5863"
      y1="319.348"
      x2="205.7623"
      y2="319.348"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="enitZalIYVj76-fill-0" offset="0%" stop-color="#fad0c6" />
      <stop id="enitZalIYVj76-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="enitZalIYVj90-fill"
      x1="212.6992"
      y1="225.5923"
      x2="215.3355"
      y2="247.4734"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="enitZalIYVj90-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="enitZalIYVj90-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="enitZalIYVj92-fill"
      x1="209.0582"
      y1="247.3409"
      x2="212.2217"
      y2="270.0129"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="enitZalIYVj92-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="enitZalIYVj92-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="enitZalIYVj94-fill"
      x1="207.5249"
      y1="267.8955"
      x2="210.6885"
      y2="289.513"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="enitZalIYVj94-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="enitZalIYVj94-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
  </defs>
  <g id="enitZalIYVj2_to" transform="translate(208.10616,135.885106)">
    <g id="enitZalIYVj2_tr" transform="rotate(0)">
      <g id="enitZalIYVj2" transform="translate(-68.042294,-139.258568)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.3491-.9371 0.9371 0.3491 57.716816 138.186372)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj5_to" transform="translate(215,137.386008)">
    <g id="enitZalIYVj5_tr" transform="rotate(0)">
      <g id="enitZalIYVj5" transform="translate(-83.800003,-114.599998)" opacity="0">
        <path d="M87.3,114.6c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj7_to" transform="translate(214.988747,140.099981)">
    <g id="enitZalIYVj7_tr" transform="rotate(2160)">
      <g id="enitZalIYVj7" transform="translate(0.035652,-108.832832)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.3491-.9371 0.9371 0.3491-10.361144 107.760854)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj10_to" transform="translate(218.378422,136.975643)">
    <g id="enitZalIYVj10_tr" transform="rotate(1800)">
      <g id="enitZalIYVj10" transform="translate(-31.681741,-175.683182)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.349-.9371 0.9371 0.349 21.356419 174.612698)"
            fill="#80bf74"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj13_to" transform="translate(212.542186,143.635142)">
    <g id="enitZalIYVj13_tr" transform="rotate(0)">
      <g id="enitZalIYVj13" transform="translate(-198.647186,-50.248066)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.3649 0.3649 0.931 194.518459 44.509276)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj16_to" transform="translate(211.077076,138.80973)">
    <g id="enitZalIYVj16_tr" transform="rotate(0)">
      <g id="enitZalIYVj16" transform="translate(-105.421234,-58.199997)" opacity="0">
        <g>
          <path d="M103.7,66.2l-1.8-3c.6-.4,5.9-3.9,2.3-11.5l3.2-1.5c4,8.6-.7,14.2-3.7,16Z" fill="#a47db7" />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj19_to" transform="translate(215.896434,130.87317)">
    <g id="enitZalIYVj19_tr" transform="rotate(-1080)">
      <g id="enitZalIYVj19" transform="translate(-3.631245,-2.499635)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7542-.6567 0.6567 0.7542-2.684249 5.678179)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj22_to" transform="translate(201.556881,157.182267)">
    <g id="enitZalIYVj22_tr" transform="rotate(-1800)">
      <g id="enitZalIYVj22" transform="translate(-29.131314,11.059706)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7543-.6566 0.6566 0.7543 22.81531-7.882019)"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj25_to" transform="translate(199.94145,131.447031)">
    <g id="enitZalIYVj25_tr" transform="rotate(1800)">
      <g id="enitZalIYVj25" transform="translate(-108.920818,-4.8)" opacity="0">
        <g>
          <path
            d="M102.1,-7.9l5.6,2.1c-.4,1.2-3.8,11.4,9.1,17.9l-2.7,5.4c-14.4-7.3-14.1-19.8-12-25.4Z"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj28_to" transform="translate(199.488382,134.68878)">
    <g id="enitZalIYVj28_tr" transform="rotate(1800)">
      <g id="enitZalIYVj28" transform="translate(-331.020844,1.100001)" opacity="0">
        <g>
          <path
            d="M324.2,-13.8l5.6,2.1c-.4,1.2-3.8,11.4,9.1,17.9l-2.7,5.4c-14.4-7.3-14.1-19.8-12-25.4Z"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj31_to" transform="translate(209.005987,139.70081)">
    <g id="enitZalIYVj31_tr" transform="rotate(0)">
      <g id="enitZalIYVj31" transform="translate(-285.257523,-78.740002)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.365 0.365 0.931 281.128 73.0014)"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj34_to" transform="translate(195.168325,137.166784)">
    <g id="enitZalIYVj34_tr" transform="rotate(1800)">
      <g id="enitZalIYVj34" transform="translate(-402.377197,-68.484085)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.349-.9371 0.9371 0.349 392.051896 67.412915)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj37_to" transform="translate(194.453319,135.4)">
    <g id="enitZalIYVj37_tr" transform="rotate(1800)">
      <g id="enitZalIYVj37" transform="translate(-409.200012,-48.200001)" opacity="0">
        <path
          d="M412.7,48.2c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c2,0,3.5,1.5,3.5,3.5Z"
          fill="#ec5f99"
        />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj39_to" transform="translate(214.485288,141.694732)">
    <g id="enitZalIYVj39_tr" transform="rotate(1800)">
      <g id="enitZalIYVj39" transform="translate(-377.34549,-75.170532)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7543-.6566 0.6566 0.7543 371.029481 78.348322)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj42_to" transform="translate(210.300085,139.393025)">
    <g id="enitZalIYVj42_tr" transform="rotate(0)">
      <g id="enitZalIYVj42" transform="translate(-305.366669,-41.552271)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7544-.6564 0.6564 0.7544 299.050281 44.728748)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj45_to" transform="translate(220.101959,136.311218)">
    <g id="enitZalIYVj45_tr" transform="rotate(1800)">
      <g id="enitZalIYVj45" transform="translate(-386.399994,-131.899994)" opacity="0">
        <path d="M389.9,131.9c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#fece48" />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj47_to" transform="translate(195.409552,137.400008)">
    <g id="enitZalIYVj47_tr" transform="rotate(1800)">
      <g id="enitZalIYVj47" transform="translate(-393.199982,-161)" opacity="0">
        <path d="M397.4,161c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2Z" fill="#fece48" />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj49_to" transform="translate(208.279398,142.971912)">
    <g id="enitZalIYVj49_tr" transform="rotate(0)">
      <g id="enitZalIYVj49" transform="translate(-321.850006,-138.150002)" opacity="0">
        <g>
          <path d="M316.2,144.3v-3.5c.7,0,7.1-.4,7.8-8.8l3.5.3c-.9,9.4-7.8,12-11.3,12Z" fill="#86ccce" />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj52_to" transform="translate(192.618468,135.885246)">
    <g id="enitZalIYVj52_tr" transform="rotate(1800)">
      <g id="enitZalIYVj52" transform="translate(-391.776657,-206.476723)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.9311-.3649 0.3649 0.9311 387.647811 200.737575)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj55_to" transform="translate(205.912338,138.321657)">
    <g id="enitZalIYVj55_tr" transform="rotate(0)">
      <g id="enitZalIYVj55" transform="translate(-351.146545,-207.374306)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.3651 0.3651 0.931 347.016547 201.63559)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj58_to" transform="translate(214.130471,140.485297)">
    <g id="enitZalIYVj58_tr" transform="rotate(0)">
      <g id="enitZalIYVj58" transform="translate(-353.698929,-174.399994)" opacity="0">
        <g>
          <path
            d="M346.9,161.7l5.6,2.1c-.4,1.2-3.8,11.4,9.1,17.9l-2.7,5.4c-14.4-7.3-14.2-19.8-12-25.4Z"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="enitZalIYVj61_to" transform="translate(214.09568,135.71354)">
    <g id="enitZalIYVj61_tr" transform="rotate(0)">
      <g id="enitZalIYVj61" transform="translate(-302.399994,-65.099998)" opacity="0">
        <path d="M312,65.1c0,5.3-4.3,9.6-9.6,9.6s-9.6-4.3-9.6-9.6s4.3-9.6,9.6-9.6s9.6,4.3,9.6,9.6Z" fill="#d2eaec" />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj63_to" transform="translate(212.181816,137.032907)">
    <g id="enitZalIYVj63_tr" transform="rotate(1800)">
      <g id="enitZalIYVj63" transform="translate(-95.400002,-25.799999)" opacity="0">
        <path d="M102.6,25.8c0,4-3.2,7.2-7.2,7.2s-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2Z" fill="#d2eaec" />
      </g>
    </g>
  </g>
  <g id="enitZalIYVj65_to" transform="translate(216.307146,129.428002)">
    <g id="enitZalIYVj65" transform="translate(-5.599999,-14.4)" opacity="0">
      <path d="M15.2,14.4c0,5.3-4.3,9.6-9.6,9.6s-9.6-4.3-9.6-9.6s4.3-9.6,9.6-9.6s9.6,4.3,9.6,9.6Z" fill="#d2eaec" />
    </g>
  </g>
  <g id="enitZalIYVj67_to" transform="translate(177.631822,485.31354)">
    <g id="enitZalIYVj67_tr" transform="rotate(73.936965)">
      <g transform="translate(-173.329767,-399.999984)">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <image
                    width="327"
                    height="810"
                    xlink:href="F9E3AADD6AE535FB.png"
                    preserveAspectRatio="xMidYMid meet"
                    transform="matrix(.24 0 0 0.24 137.52 249.12)"
                    opacity="0.05"
                  />
                  <g>
                    <g>
                      <path
                        d="M204.3,298.4l1.4,75c0,0-6.2,9.4-29,9.9-22.8.6-37.2-9.9-37.2-9.9l1.3-85.9c.3-17.3,13.5-31.7,30.3-32.2.5,0,1,0,1.6,0c32.7,0,31.6,30.8,31.6,43.1Z"
                        fill="url(#enitZalIYVj76-fill)"
                      />
                      <path
                        d="M205.8,346.8v90.6c0,0-3.7-.6-26.5,0-22.8.5-39.7-5.4-39.7-5.4v-85.1c0,0,14.4,10.5,37.2,9.9c22.8-.7,29-10,29-10Z"
                        fill="#00a19a"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <circle r="42.4" transform="translate(181.9 277.2)" fill="#fad0c6" />
              </g>
            </g>
            <g>
              <path
                d="M174.5,298l-4-1.2c-6.3-1.9-10-8.6-8.1-14.9l36.4-123.7c1.9-6.3,8.6-10,14.9-8.1l4,1.2c6.3,1.9,10,8.6,8.1,14.9L189.4,289.9c-1.8,6.3-8.5,10-14.9,8.1Z"
                fill="#ca9e67"
              />
            </g>
            <g>
              <circle r="72.1" transform="translate(224.8 124.7)" fill="#24224e" />
            </g>
            <g>
              <circle r="59.9" transform="translate(224.8 124.7)" fill="#1a1731" />
            </g>
            <text
              dx="0"
              dy="0"
              font-family='"enitZalIYVj1:::Lato"'
              font-size="48.3747"
              font-weight="400"
              transform="matrix(.9888 0.1491-.1491 0.9888 181.977 136.739)"
              fill="#fff"
            >
              <![CDATA[ BID ]]>
            </text>
            <path
              d="M141.1,265.6l18.5-64.7c1.1-4.2,4.3-7.6,8.4-8.7c3.1-.8,6.8-.4,10.1,3.5c5.7,6.6,6.6,14.4,6.7,18.1c0,1.3-.2,2.5-.5,3.7l-3.2,11c-1.1,3.8-3.3,7.2-6.3,9.8l-3.7,3.2"
              fill="#fad0c6"
            />
          </g>
          <g>
            <g>
              <path
                d="M234.8,245.9L196,250.4c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.8,6.4-3.8,12.2-10.2,12.9Z"
                fill="url(#enitZalIYVj90-fill)"
              />
            </g>
            <g>
              <path
                d="M231.4,267.8l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.7,6.4-3.9,12.2-10.2,12.9Z"
                fill="url(#enitZalIYVj92-fill)"
              />
            </g>
            <g>
              <path
                d="M229.9,288.4l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.8,6.4-3.8,12.2-10.2,12.9Z"
                fill="url(#enitZalIYVj94-fill)"
              />
            </g>
            <g>
              <path
                d="M225.1,309.1l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.7,6.3-3.9,12.2-10.2,12.9Z"
                fill="#fad0c6"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
